import {FormControl, FormField} from 'platform/components';
import {Grid, GridItem} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {VehicleInformationFormType} from '../types';

interface VehicleInformationFormProps extends RequiredTestIdProps {
  control: FormControl<VehicleInformationFormType>;
}

export function VehicleInformationForm(props: VehicleInformationFormProps) {
  return (
    <Grid columns={4}>
      <GridItem span={1}>
        <FormField
          control={props.control}
          type="integer"
          name="currentMileage"
          label={i18n.t('entity.vehicle.labels.mileage')}
          suffix={i18n.t('general.metric.km')}
          data-testid={suffixTestId('currentMileage', props)}
        />
      </GridItem>
      <GridItem span={3}>
        <FormField
          control={props.control}
          type="text"
          name="additionalInformation"
          label={i18n.t('entity.vehicle.labels.additionalInformation')}
          data-testid={suffixTestId('additionalInformation', props)}
        />
      </GridItem>
    </Grid>
  );
}
